<div style="display: flex; gap: 8px; align-items: center; width: 100%">
  <mat-form-field appearance="outline" class="no-hint" style="flex: 1">
    <mat-label>Buscar SIM disponible</mat-label>
    <input
      matInput
      [formControl]="busqueda"
      [matAutocomplete]="autoSim"
      placeholder="ICCID o número de teléfono"
      (focus)="alEnfocar()"
    />
    <mat-icon matPrefix>search</mat-icon>
    <mat-autocomplete
      #autoSim="matAutocomplete"
      (optionSelected)="elegir($event.option.value)"
    >
      @for (sim of opciones; track sim._id) {
        <mat-option [value]="sim">{{ etiqueta(sim) }}</mat-option>
      }
      @if (buscado && !buscando && !opciones.length) {
        <mat-option disabled>No hay SIMs disponibles que coincidan</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  @if (conSim) {
    <button
      irxBoton="secundario"
      type="button"
      tooltip="Vaciar los datos para cargar una SIM nueva"
      (click)="nueva()"
    >
      <mat-icon>add</mat-icon>
      Nueva SIM
    </button>
  }
</div>
